import React, { useState, useEffect } from 'react';

import Menue from "./Menue";
import Title from "./Title";
import Hashtag from "./Hashtag";
import News from "./News";
import Events from "./Events";
import EventCalendar from "./EventCalendar";
import Wellcome from "./Wellcome";
import About from "./About";
import Chronic from "./Chronic";
import History from "./History";

import Team from "./Team";
import Occupation from "./Occupation"



import './styles/parallax.css';
import './styles/style_copy.css';
import './styles/style_mobile_copy.css';
import './styles/style_desktop_copy.css';
import './styles/footer.css'




function App({config}) {

  const [count, setCount] = useState(0);
  useEffect(() => {    
    console.log("getCounter");
    fetchCounter();
  },[]);

  

function fetchCounter(){
  
  fetch('./getCounter.php')
  .then(response => response.text()) 
  .then(textString => {
    setCount(textString)  
  }).catch();

}

  const callback = (entries) => {
    // The entries variable will contain the list of
           // elements that you are observing. When ever 
           // intersection occurs, you need to do forEach loop 
           // to find which one intersected. 
           // For this we check a flag on the element called "isIntersecting"
           entries.forEach(
            (entry) => {
                if (entry.isIntersecting) {
                    console.log("The element is intersecting >");
                    //If intersecting then attach keyframe animation.
                   //We do this by assigning the data attribute 
                   //we coded in the markup to the style.animation 
                   //of the element
                    entry.target.style.animation = entry.target.dataset.animate;
                } else {
                    //We take of the animation if not in view
                    entry.target.style.animation="none";
                }
            }
        ); 
  }
  
  //1]Create a new intersectionObserver object, 
  //which will accept a callback function as 
  //a parameter.
  
  let observer = new IntersectionObserver(callback);
  
  
  //2]Select all elements that have ".animate" 
  //class.In our case we have three 
  //elements (.image,<p> and h<2>).
  
  const animationItems = document.querySelectorAll('.animate');
  
  
  //3]Loop through selected elements and add to the
  //observer watch list.      
  
  animationItems.forEach(item => {
    observer.observe(item)         
  })




  return (
    <>   
      <Menue/>

      <div class="parallax0 animate">
        <Title id={"title"} config={config}/>  
      </div>
      
      <div class="content_welcome">
        <Hashtag id={"wellcome"} title={"Der Männerchor Opperode 1861 e.V. heißt Sie willkommen."} /> 
        <Wellcome config={config}/>       
      </div>

      

      <div class="parallax_mcotonne ">  
        <div className="parallaxe-text">{config.name}</div>
      </div>

      <div class="content_news">
        {/* <Hashtag id={"news"} title={"Aktuelles"}/>
          <News /> */}
        {
          config.events?
          <Hashtag id={"events"} title={"Demnächst"}/>:null
        }

        <Events/>
        
      </div>

      <div class="parallax_night">  
        <div className="parallaxe-text">{config.name}</div>
      </div>

      <div class="content_news">
        {/* <Hashtag id={"news"} title={"Aktuelles"}/>
          <News /> */}
        {
          config.events?
          <Hashtag id={"eventcalendar"} title={"Veranstaltungskalender"}/>:null
        }       
        <EventCalendar/>
      </div>

      <div class="parallax_news">
        <div className="parallaxe-text">Zusammen singen, zusammen bleiben.</div>            
      </div>
      
      <div class="content_teams">
        <Hashtag id={"team"} title={"Unser Vorstand"}/>
        <Team />
      </div>

      <div class="parallax2">
      <div className="parallaxe-text">Haltet Frau Musica in Ehren!</div>     
      </div>

      <div class="content_teams">
        <Hashtag id={"occupation"} title={"Unsere Besetzung"}/>
        <Occupation /> 
      </div>

      <div class="parallax2">
        <div className="parallaxe-text">Wir blicken auf 160. Jahre “Opperöder Männerchor“!</div>     
      </div>

      <div class="content_about">
        <Hashtag id={"about"} title={"Lernen Sie den Verein kennen."}/>
        <About config={config}/>
        <Hashtag id={"history"} title={'Geschichte des Vereins “' + config.name +'“ '}/>
        <History />
        <Hashtag  id={"chronic"} title={"Chronik"}/>
        <Chronic/>
      </div>

      <div class="parallax22">
        <div className="parallaxe-text">Wir danken für Ihren Besuch auf dieser Seite.</div> 
      </div>


      <div class="parallax_end">
        <div class="center">
          <img style={{ marginRight:10}} width="25"  src='./icons/user_plus.png' />
          <div >{count}</div>

        </div>
        <div style={{color:'white', cursor:'pointer'}} onClick={()=>{
          document.getElementById("footer").style.height='200px';
          document.getElementById("footer").style.opacity=1;

        }}>Impresssum</div>
      </div>

      <div>
        <div id="footer" className='footer'>
        <div className='footer-closer' onClick={()=>{
          document.getElementById("footer").style.height='0px';
          document.getElementById("footer").style.opacity=0;


        }}>Schliessen</div>
        <div className='footer-header'>Impresssum</div>
           <div className='footer-title'>Männerchor Opperode 1861 e.V.</div>
           <div className='footer-text'>maennerchor-opperode1861ev.de</div>
           <div className='footer-text'>E-Mail: vorstand(at)maennerchor-opperode1861ev.de</div>
        </div>
      </div>
    </>
  );
}

export default App;
